module.exports = __webpack_public_path__ + "static/media/CourseTimeTracked.fda05f09.svg";